import { Modal, type ModalProps } from '@matillion/component-library'

export const DesignerModal = (props: ModalProps) => {
  // TODO: temporarily removed to allow backspace delete in modals
  // a fix will be looked at in https://matillion.atlassian.net/browse/DPCD-906
  // usePreventKeyboardPropagation()
  return <Modal {...props} />
}
